// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30bkm","label":"styles_label__3APrB"};